module.exports = __webpack_public_path__ + "static/media/btn_03.e184648e.png";